import { List, Map } from 'immutable';
import * as types from '../constants/actionTypes';

const initialState = Map({
  gptReviewsFetching: false,
  gptReviewsUpdating: false,
  gptReviews: List(),
  numberPages: 0,
  gptScoreTrendsFetching: false,
  gptScoreTrendsError: false,
  gptScoreTrends: List(),
  gptScoreTrendsResolution: null,
  gptPromptVersionVolume: List(),
  gptPromptVersionVolumeVersions: List(),
  gptBucketTrendsFetching: false,
  gptBucketTrendsError: false,
  gptBucketTrendsResolution: null,
  gptBuckets: List(),
  gptBucketVolume: List(),
  gptBucketAverageScore: List(),
  gptReviewBucketsFetching: false,
  gptReviewBuckets: [],
  // Persisted filter selections for the review list (see setGptReviewFilters).
  // Defaults mirror the list's initial query: scores <= 4, not yet reviewed.
  filters: Map({
    maxScore: 4,
    reviewed: 0,
    promptVersion: "",
    ccid: "",
    bucket: "",
    page: 1
  })
});

export default function(state = initialState, action) {
  switch (action.type) {
    case types.GPT_REVIEWS_FETCHING:
      return state.set('gptReviewsFetching', true);
    case types.GPT_REVIEWS_FETCHED:
      return gptReviewsFetched(state, action.payload);
    case types.GPT_REVIEWS_FETCH_ERROR:
      return state.set('gptReviewsFetching', false);
    case types.GPT_REVIEW_UPDATING:
      return state.set('gptReviewsUpdating', true);
    case types.GPT_REVIEW_UPDATED:
      return updateGptReviewedValue(state, action.payload);
    case types.GPT_REVIEW_UPDATE_ERROR:
      return state.set('gptReviewsUpdating', false);
    case types.GPT_PROMPT_VERSIONS_FETCHED:
      return gptPromptVersionsFetched(state, action.payload);
    case types.GPT_PROMPT_VERSIONS_FETCHING:
      return state.set('gptPromptVersionsFetching', true);
    case types.GPT_PROMPT_VERSIONS_FETCH_ERROR:
      return state.set('gptPromptVersionsFetching', false);
    case types.GPT_SCORE_TRENDS_FETCHING:
      return state.set('gptScoreTrendsFetching', true).set('gptScoreTrendsError', false);
    case types.GPT_SCORE_TRENDS_FETCHED:
      return gptScoreTrendsFetched(state, action.payload);
    case types.GPT_SCORE_TRENDS_FETCH_ERROR:
      return state
        .set('gptScoreTrendsFetching', false)
        .set('gptScoreTrendsError', true)
        .set('gptScoreTrends', List())
        .set('gptPromptVersionVolume', List())
        .set('gptPromptVersionVolumeVersions', List())
        .set('gptScoreTrendsResolution', null);
    case types.GPT_BUCKET_TRENDS_FETCHING:
      return state.set('gptBucketTrendsFetching', true).set('gptBucketTrendsError', false);
    case types.GPT_BUCKET_TRENDS_FETCHED:
      return gptBucketTrendsFetched(state, action.payload);
    case types.GPT_BUCKET_TRENDS_FETCH_ERROR:
      return state
        .set('gptBucketTrendsFetching', false)
        .set('gptBucketTrendsError', true)
        .set('gptBuckets', List())
        .set('gptBucketVolume', List())
        .set('gptBucketAverageScore', List())
        .set('gptBucketTrendsResolution', null);
    case types.GPT_BUCKETS_FETCHING:
      return state.set('gptReviewBucketsFetching', true);
    case types.GPT_BUCKETS_FETCHED:
      return state
        .set('gptReviewBuckets', action.payload || [])
        .set('gptReviewBucketsFetching', false);
    case types.GPT_BUCKETS_FETCH_ERROR:
      return state.set('gptReviewBucketsFetching', false);
    case types.GPT_REVIEW_FILTERS_SET:
      return state.set('filters', state.get('filters').merge(action.payload));
    default:
      return state;
  }
}

function gptReviewsFetched(state, payload) {
  return state
    .setIn(['gptReviews'], payload.gptReviews)
    .set('numberPages', payload.numberPages)
    .set('gptReviewsFetching', false);
}

function updateGptReviewedValue(state, payload) {
  const { id, reviewed } = payload;
  const gptReviews = state.get('gptReviews');
  const updatedGptReviews = gptReviews.map(gptReview => {
    if (gptReview.id === id) {
      gptReview.reviewed = reviewed;
    }
    return gptReview;
  });
  return state.set('gptReviews', updatedGptReviews).set('gptReviewsUpdating', false);
}

function gptPromptVersionsFetched(state, payload) {
  return state
    .setIn(['gptPromptVersions'], payload)
    .set('gptPromptVersionsFetching', false);
}

function gptScoreTrendsFetched(state, payload) {
  return state
    .set('gptScoreTrends', List(payload.buckets || []))
    .set('gptScoreTrendsResolution', payload.resolution || null)
    .set('gptPromptVersionVolume', List(payload.promptVersionBuckets || []))
    .set('gptPromptVersionVolumeVersions', List(payload.promptVersions || []))
    .set('gptScoreTrendsFetching', false)
    .set('gptScoreTrendsError', false);
}

function gptBucketTrendsFetched(state, payload) {
  return state
    .set('gptBuckets', List(payload.buckets || []))
    .set('gptBucketVolume', List(payload.bucketVolumeBuckets || []))
    .set('gptBucketAverageScore', List(payload.bucketAverageScoreBuckets || []))
    .set('gptBucketTrendsResolution', payload.resolution || null)
    .set('gptBucketTrendsFetching', false)
    .set('gptBucketTrendsError', false);
}
